module.exports = __webpack_public_path__ + "media/images/courses/sad-face-38f53de31391cb1198346ee6ebc18bc9.png";